
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import GalleryHero from './components/GalleryHero';
import GalleryGrid from './components/GalleryGrid';
import GalleryCTA from './components/GalleryCTA';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema, generateGallerySchema } from '../../utils/seo';

export default function GalleryPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const galleryImages = [
    { url: 'https://public.readdy.ai/ai/img_res/e12277b0453ac8caaa0d21a22ec1aa29.jpg', caption: 'Interior living room painting – Watford' },
    { url: 'https://readdy.ai/api/search-image?query=exterior%20house%20painting%20project%20completed%20professional%20finish%20cream%20render%20detached%20home%20Hertfordshire&width=800&height=600&seq=gal002&orientation=landscape', caption: 'Exterior house painting – Hertfordshire' },
    { url: 'https://readdy.ai/api/search-image?query=elegant%20wallpaper%20installation%20feature%20wall%20bedroom%20professional%20decorator%20Watford&width=800&height=600&seq=gal003&orientation=landscape', caption: 'Wallpaper installation – Watford bedroom' },
    { url: 'https://readdy.ai/api/search-image?query=commercial%20office%20interior%20painting%20neutral%20tones%20professional%20finish%20Hertfordshire&width=800&height=600&seq=gal004&orientation=landscape', caption: 'Commercial office painting – Hertfordshire' },
    { url: 'https://readdy.ai/api/search-image?query=kitchen%20cabinet%20painting%20transformation%20white%20gloss%20finish%20professional%20Watford&width=800&height=600&seq=gal005&orientation=landscape', caption: 'Kitchen cabinet painting – Watford' },
    { url: 'https://readdy.ai/api/search-image?query=staircase%20hallway%20painting%20neutral%20warm%20tones%20professional%20decorator%20Hertfordshire&width=800&height=600&seq=gal006&orientation=landscape', caption: 'Hallway and staircase painting – Hertfordshire' },
  ];

  useSEO({
    title: 'Painting & Decorating Portfolio Watford | Brushour Gallery',
    description: 'Browse Brushour\'s portfolio of completed painting and decorating projects across Watford and Hertfordshire. Interior painting, exterior painting, commercial work, and residential transformations.',
    keywords: 'painting gallery Watford, decorating portfolio Hertfordshire, completed projects Watford, painting examples Hertfordshire, Brushour portfolio',
    canonical: `${SITE_URL}/gallery`,
    ogImage: 'https://static.readdy.ai/image/3d769dc1e01059223eb26668720a1761/e6c157647967ffb5fa62a9e4cb4fe039.png',
    schema: [
      generateGallerySchema(galleryImages),
      generateWebPageSchema('Painting & Decorating Portfolio – Brushour Watford', 'Gallery of completed painting and decorating projects across Watford and Hertfordshire', `${SITE_URL}/gallery`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Gallery', url: `${SITE_URL}/gallery` },
      ]),
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <GalleryHero />
      <GalleryGrid />
      <GalleryCTA />
      <Footer />
    </div>
  );
}
